import {BaseNavigationModel} from "./base-navigation-model";

export class BaseUrlModel extends BaseNavigationModel {}
